var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.label ? _c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm.required ? _c('span', {
    staticClass: "text-system-error"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('textarea', _vm._b({
    staticClass: "px-3 py-3 focus:outline-none border border-neutral-300 w-full rounded-lg resize-none h-36",
    class: [{
      'is-invalid': _vm.hasErrors,
      'bg-grey cursor-not-allowed text-neutral-300': _vm.disabled
    }, _vm.error ? 'border-system-error' : 'border-neutral-300'],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event.target.value);
      },
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.action();
      }
    }
  }, 'textarea', _vm.$attrs, false)), _vm.notes ? _c('span', {
    staticClass: "text-xs text-gray-500 leading-tight inline-block mt-1"
  }, [_vm._v(_vm._s(_vm.notes))]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.error ? _c('div', {
    staticClass: "text-system-error text-left mt-1 text-sm"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }